import { cn } from "@/lib/utils";

const STYLES = {
  // placement
  "Draft": "bg-zinc-100 text-zinc-600 border-zinc-200",
  "Submitted": "bg-blue-50 text-blue-700 border-blue-200",
  "Facilities Notified": "bg-blue-50 text-blue-700 border-blue-200",
  "Awaiting Facility Response": "bg-orange-50 text-orange-700 border-orange-200",
  "Facility Accepted": "bg-green-50 text-green-700 border-green-200",
  "Student Confirmed": "bg-green-50 text-green-700 border-green-200",
  "Paperwork Assigned": "bg-amber-50 text-amber-700 border-amber-200",
  "Paperwork Complete": "bg-green-50 text-green-700 border-green-200",
  "Ready for Start": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "Active Placement": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "Completed": "bg-zinc-100 text-zinc-600 border-zinc-200",
  "Cancelled": "bg-zinc-100 text-zinc-500 border-zinc-200 line-through",
  "Non-Placement Alert": "bg-red-600 text-white border-red-700 shadow-sm",
  "Needs Re-routing": "bg-red-50 text-red-700 border-red-300 font-semibold",
  // engagement events
  "Requested": "bg-amber-50 text-amber-700 border-amber-200",
  "Scheduled": "bg-blue-50 text-blue-700 border-blue-200",
  "Declined": "bg-red-50 text-red-700 border-red-200",
  // clearance
  "Not Started": "bg-zinc-100 text-zinc-600 border-zinc-200",
  "Paperwork In Progress": "bg-amber-50 text-amber-700 border-amber-200",
  "Pending Review": "bg-orange-50 text-orange-700 border-orange-200",
  "Cleared to Start": "bg-green-50 text-green-700 border-green-200",
  "Not Cleared": "bg-red-50 text-red-700 border-red-200",
  // paperwork
  "Assigned": "bg-zinc-100 text-zinc-600 border-zinc-200",
  "In Progress": "bg-amber-50 text-amber-700 border-amber-200",
  "Submitted_pw": "bg-blue-50 text-blue-700 border-blue-200",
  "Approved": "bg-green-50 text-green-700 border-green-200",
  "Rejected": "bg-red-100 text-red-800 border-red-300 font-bold",
  "Waived": "bg-zinc-100 text-zinc-500 border-zinc-200",
  // responses
  "Pending": "bg-orange-50 text-orange-700 border-orange-200",
  "Accepted": "bg-green-50 text-green-700 border-green-200",
  "Denied": "bg-red-50 text-red-700 border-red-200",
  // recruiting / generic
  "Interested": "bg-blue-50 text-blue-700 border-blue-200",
  "Hired": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "Active": "bg-green-50 text-green-700 border-green-200",
  "Invited — SSO": "bg-violet-50 text-violet-700 border-violet-200",
  "No Instructors": "bg-amber-50 text-amber-700 border-amber-200",
  "Pending Email Verification": "bg-amber-50 text-amber-700 border-amber-200",
  "Pending Activation": "bg-amber-50 text-amber-700 border-amber-200",
  // student onboarding tasks
  "Awaiting Coordinator": "bg-amber-50 text-amber-700 border-amber-200",
  "Confirm New Time": "bg-orange-50 text-orange-700 border-orange-300 font-semibold",
  "Pending Confirmation": "bg-amber-50 text-amber-700 border-amber-200",
  "Complete": "bg-green-50 text-green-700 border-green-200",
  "Started": "bg-orange-50 text-orange-700 border-orange-300",
};

// The facility decision is always spoken as Yes / No across the platform.
const LABELS = {
  "Facility Accepted": "Facility Yes",
  "Facility Denied": "Facility No",
  "Accepted": "Yes",
  "Denied": "No",
};

export function StatusBadge({ status, className }) {
  if (!status) return null;
  const style = STYLES[status] || "bg-zinc-100 text-zinc-700 border-zinc-200";
  const urgent = status === "Non-Placement Alert";
  return (
    <span
      data-testid={`status-badge-${status.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
      className={cn(
        "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium whitespace-nowrap",
        style, urgent && "cc-urgent", className
      )}
    >
      {LABELS[status] || status}
    </span>
  );
}
